import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "95ce563f-bd34-400a-8fcc-168179fd8020",
    content: "Any MUSHRA experiment will contain a reference stimulus and at least an anchor in the stimulus pool. ",
    options: {},
  },
  {
    id: "b3275db4-9812-4388-8b71-5d5e2d3b7d96",
    content: "In a forced-choice experiment, it is impossible for the participant to guess the correct answer.",
    options: {},
  },
  {
    id: "9184cf71-ecf3-4a3e-b603-8cd189c842bd",
    content:
      "In a pairwise comparison experiment, the order in which stimuli are presented does not matter. Therefore each couple of stimuli has to be tested only once.",
    options: {},
  },
];

export const task: Task = {
  id: "decbfdbb-a458-4ce4-b231-3fc4076b441a",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["95ce563f-bd34-400a-8fcc-168179fd8020"],
};
